export default __webpack_public_path__ + "static/media/2_2.6f97a60f.jpg";